import cheerio from 'cheerio';

import appError from './appError.js';
import isObject from './isObject.js';

/**
 * Modify HTML template of a component
 * @param {object[]|string} defaultTemplate Default template (HTML before modification default-default, Object after)
 * @param {object[]} modification Modification object
 * @param {string} modification.query Query selector (e.g. '.product')
 * @param {string} modification.position Action which should happen with the element (replace, before, after)
 * @param {string} modification.content A new HTML content
 * @returns {string}
 */
export default (defaultTemplate, modification = []) => {
	let modifiedTemplate = defaultTemplate;
	if (isObject(modifiedTemplate)) {
		modifiedTemplate = modifiedTemplate.template || modifiedTemplate.extends.template;
	}
	// Load in the HTML
	const $ = cheerio.load(modifiedTemplate, {
		decodeEntities: false,
		lowerCaseTags: false,
		lowerCaseAttributeNames: false,
		recognizeSelfClosing: true
	});
	if (Array.isArray(modification) && modification.length > 0) {
		modification.forEach(({ query, position, content }) => {
			if (query && position && content) {
				const $existingElements = $(query);
				if ($existingElements.length) {
					$existingElements.each((index, existingElement) => {
						// Replace element
						if (position === 'replace') {
							$(existingElement).replaceWith(content);
							// Place element in front of the selected query
						} else if (position === 'before') {
							$(existingElement).before(content);
							// Place element behind of the selected query
						} else if (position === 'after') {
							$(existingElement).after(content);
						} else {
							appError('Invalid position', {
								code: 'APP_BACKEND_UTIL',
								origin: 'modifyTemplates',
								description: 'There is invalid position value defined. It has to be one of the "replace/before/after" value'
							});
						}
					});
				} else {
					appError('Invalid query', {
						code: 'APP_BACKEND_UTIL',
						origin: 'modifyTemplates',
						description: 'The query element has not been found (does not exist)'
					});
				}
			}
		});
	}
	// Use the updated (replaced) html (components)
	return $.html();
};
